module.exports = __webpack_public_path__ + "static/media/YF84_3.241d148a.jpg";